// @flow weak

import React from 'react';
import _ from 'lodash';
import { $set, update } from 'qim';

import CheckboxField from 'app/common/components/CheckboxField';
import CodeEditor from 'app/developer-v3/components/CodeEditor';
import ImageField from 'app/developer-v3/components/ImageField';
import RadioArray from 'app/common/components/RadioArray';
import SingleCheckboxField from 'app/developer-v3/components/SingleCheckboxField';
import { firstItemIfArray } from 'app/common/CommonUtils';
import { wrapWithFormaticField } from 'app/common/utils/FormaticUtils';

const plugin = config => {
  const {
    createElement_Field: origCreateElement_Field,
    createElement_PrettySelect: origCreateElement_PrettySelect,
    createElement_RequiredLabel: origCreateElement_RequiredLabel,
    fieldHelpText: origFieldHelpText,
    fieldMessages,
  } = config;

  return {
    createElement_BooleanInput(props) {
      return <CheckboxField {...props} />;
    },

    createElement_CheckboxBooleanTitled(props) {
      return wrapWithFormaticField(SingleCheckboxField, props);
    },

    createElement_CodeEditor(props) {
      const { maxLines } = props.field;
      return wrapWithFormaticField(CodeEditor, { ...props, maxLines });
    },

    // Lets us add required labels to a fields grouping
    createElement_Field(props, children) {
      const { field } = props;

      if (field.required && field.asField) {
        const newProps = update(['classes', 'fm-field', $set(true)], props);
        return origCreateElement_Field(newProps, children);
      }

      return origCreateElement_Field(props, children);
    },

    createElement_PairedServiceSelector(props) {
      const { meta, help } = props.field;
      const warning =
        _.isEmpty(meta.pairedServices) && fieldMessages.createHelpBox(help);

      const newProps = update(
        [
          ['field', 'choices', $set(meta.pairedServices)],
          ['field', 'meta', 'warnings', props.field.key, $set(warning)],
        ],
        props
      );

      return origCreateElement_PrettySelect(newProps);
    },

    createElement_RadioArray(props) {
      return wrapWithFormaticField(RadioArray, props);
    },

    createElement_RequiredLabel(props) {
      return props.field.type === 'radio-array'
        ? null
        : origCreateElement_RequiredLabel(props);
    },

    createElement_SingleCheckbox(props) {
      return wrapWithFormaticField(SingleCheckboxField, props);
    },

    fieldHelpText(field) {
      const helpText: string = (firstItemIfArray(
        origFieldHelpText(field)
      ): any);

      // Wrap help text with <p> tag, to make styles work right with HTML help text.
      // But don't wrap with <p> tag if it's already wrapped.
      if (helpText && !helpText.match(/^\s*<p>/i)) {
        return `<p>${helpText}</p>`;
      }

      // Don't wrap empty help text with <p> - it messes things up
      return helpText;
    },

    createElement_Upload(props) {
      return wrapWithFormaticField(ImageField, props);
    },
  };
};

export default plugin;
